<!-- 顶部导航栏 -->
<template>
  <div class="topBar">
    <img class="logo" :src="isSp==1 ? require('../assets/sg/sg_logo_navigation_bar.png') : require('../assets/topBar/navigation_logo.png')">
    <div class="center canClick">
      <div @click="goToPage('home')" v-if="$hasPermission('homepage') && isSp!=1" :class="'menuItem '+($store.state.topIndex==0)">
        {{this.$store.state.language.homePage}}
      </div>
      <div @click="goToPage('fullCalendar')" v-if="$hasPermission('calendar') && isSp!=1" :class="'menuItem '+($store.state.topIndex==1)">
        {{this.$store.state.language.calendar}}
      </div>
      <div v-if="$hasPermission('schedule')&&isSp!=1" @click="goToPage('teClass')" :class="'menuItem '+($store.state.topIndex==6)">
        {{this.$store.state.language.session}}
      </div>
      <div @click="goToPage('task')" v-if="$hasPermission('task') && isSp!=1" :class="'menuItem '+($store.state.topIndex==2)">
        {{this.$store.state.language.task}}
      </div>
      <div v-if="$hasPermission('student')&&isSp!=1" @click="goToPage('family')" :class="'menuItem '+($store.state.topIndex==3)">
         {{this.$store.state.language.student}}
      </div>
      <div v-if="$hasPermission('project')&&isSp!=1" @click="goToPage('project')" :class="'menuItem '+($store.state.topIndex==4)">
        {{this.$store.state.language.program}}
      </div>
      
      <div v-if="$hasPermission('university')&&isSp!=1" @click="goToPage('university')" :class="'menuItem '+($store.state.topIndex==5)">
        {{this.$store.state.language.school}}
      </div>
      <div v-if="$hasPermission('staff')&&isSp!=1" @click="goToPage('teacher')" :class="'menuItem '+($store.state.topIndex==14)">
        {{this.$store.state.language.beMember}}
      </div>
      <div v-if="($hasPermission('setup')&&isSp!=1)||($store.state.isAdmin&&isSp!=1)" @click="goToPage('setup')" :class="'menuItem '+($store.state.topIndex==15)">
        {{this.$store.state.language.setup}}
      </div>
      <div v-if="$hasPermission('sgData')&&isSp==1" @click="goToPage('chartData')" :class="'menuItem '+($store.state.topIndex==16)">
        数据
      </div>
      <div v-if="$hasPermission('sgSchool')&isSp==1" @click="goToPage('school')" :class="'menuItem '+($store.state.topIndex==17)">
        院校
      </div>
      <div v-if="$hasPermission('sgBanner')&&isSp==1" @click="goToPage('banner')" :class="'menuItem '+($store.state.topIndex==18)">
        开屏图
      </div>
    </div>
    <div class="right canClick">
      <!-- <Poptip  v-if="isSp!=1" @on-popper-show="biaoYidu()" style="height: 22px;margin-right: 40px;" class="canClick" :transfer="true" trigger="click" placement="bottom">
        <Badge class="ling" :count="newsKaiguan?weidu:0" :overflow-count="99">
          <img src="../assets/topBar/tongzhi@2x.png">
        </Badge>
        <div class="tipsWai" slot="content">
          <div class="tixing" v-if="xiaoxi.length<=4">
            <div class="list" v-for="(item,index) in xiaoxi" :key="index">
              <div class="left">
                <p v-if="item.typeText">{{item.typeText[0]}}</p>
                <p>{{item.content}}</p>
                <p><span>{{item.gmtCreate}}</span></p>
              </div>
              <div v-if="item.value&&item.type!=6&&item.type!=8&&item.type!=10" @click="goToMsgPage(item)" class="right canClick">
                <span>查看</span><Icon type="md-arrow-round-forward" />
              </div>
            </div>
          </div>
          <div class="tixing" style="height: 400px;" v-else>
            <div class="outer-container">
              <div class="inner-container" :style="'width: calc(100% + '+$store.state.scrollbarWidth+'px);'">
                <div class="content">
                  <div class="list" v-for="(item,index) in xiaoxi" :key="index">
                    <div class="left">
                      <p v-if="item.typeText">{{item.typeText[0]}}</p>
                      <p>{{item.content}}</p>
                      <p><span>{{item.gmtCreate}}</span></p>
                    </div>
                    <div v-if="item.type!=6&&item.type!=8&&item.type!=10&&item.value" @click="goToMsgPage(item)" class="right canClick">
                      <span>{{$store.state.language.viewDetail}}</span><Icon type="md-arrow-round-forward" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p v-if="xiaoxi.length>0" class="tixingText">{{$store.state.language.notificationButtom}}</p>
          <p v-else class="tixingText">{{$store.state.language.noData}}</p>
        </div>
      </Poptip> -->
      <!-- <a href="https://beedu.sharepoint.com/sites/BEConnectPortal/Lists/Bugs%20Collecting/AllItems.aspx" target="_blank" style="margin-right:40px"><Icon type="md-help-circle" color="#fff" size="28" title="Please submit your system questions here"/></a> -->
      <div class="renWai">
        <p v-if="isSp==1 || !$hasPermission('staff:info')">
          <Avatar class="ren" v-if="$store.state.basicInfo.avatar" :src="$store.state.headUrl+$store.state.basicInfo.avatar" size="small" />
          <Avatar class="ren" v-else size="small" />
        </p>
        <p @click="goToPersonal()" v-else>
          <Avatar class="ren" v-if="$store.state.basicInfo.avatar" :src="$store.state.headUrl+$store.state.basicInfo.avatar" size="small" />
          <Avatar class="ren" v-else size="small" />
        </p>
        <div :class="isSp?'erji erjiSg':'erji'">
          <div :class="isSp?'sanjiao sanjiaoSg':'sanjiao'"></div>
          <div class="people">
            <p>{{$store.state.basicInfo.showName}}</p>
            <p>{{$store.state.basicInfo.username}}</p>
          </div>
          <!-- <div class="one" v-if="isSp!=1">
            <p>{{$store.state.language.reminderSet}}</p>
            <i-switch @on-change="changeNews" v-model="newsKaiguan" />
          </div> -->
          <div @click="editPwd()" class="one">
            <p>{{$store.state.language.changePw}}</p>
            <Icon type="ios-arrow-forward" size="20" />
          </div>
          <div @click="loginOut()" class="loginOut">
            <p>{{$store.state.language.logOut}}</p>
          </div>
          <div class="belogo">
            <img src="../assets/topBar/navigation_logo.png">
            <p>A Proud BE Family Member</p>
          </div>
        </div>
      </div>
      <div class="location" v-if="isSp!=1" @click="changeLocation">
        <img class="addrIcon" src="../assets/topBar/me_icon_position@2x.png">
        <div class="addr">
          <p><span> {{$store.state.timeZoneHelp[$store.getters.areaCodeId]}}</span></p>
        </div>
        <img class="timeIcon" src="../assets/topBar/shijian@2x.png">
        <div class="time">{{timeArr}}</div>
      </div>
      <div @click="changeLanguage()" :class="'canClick language language'+$store.state.languageType"  v-if="isSp!=1">
        <p>EN</p><p>中</p>
      </div>
    </div>
    <Modal v-model="locationModal" :footer-hide="true">
      <location-modal :basicInfo="$store.state.basicInfo" @closeLocationModal="closeLocationModal"></location-modal>
    </Modal>
  </div>
</template>

<script>
import locationModal from './locationModal.vue';
import moment from "moment";
export default {
  name: 'topBar',
  props: {},
  inject: ['reload'],
  components: {
    locationModal
  },
  data() {
    return {
      isSp:0,
      timeArr: '00:00',
      xiaoxi: [],// 消息列表
      pageNum: 1,// 页码
      pageSize: 10,// 每页条目
      weidu: 0,// 未读消息条目
      newsKaiguan: true,// 消息提醒开关
      roleId: 0,// 角色ID
      // quanxian: [],// 当前角色权限(1日历,2任务,3学生,4项目,5院校,6课次,10教师,11顾问,12排课人员,13院校管理,14BE成员,15系统设置,16数据SP,17院校SP,18开屏图SP)
      locationModal:false,
    };
  },
  methods: {
    changeLocation(){
      this.locationModal = true
    },
    closeLocationModal() {
      this.selPersonal()
      this.reload()
      this.$forceUpdate()
      this.locationModal = false;
    },
    
    // 退出登录
    loginOut: function() {
      this.$router.replace({ name: 'login', params: { type: 1 } });
      localStorage.removeItem('userInfo')
      localStorage.removeItem('isSp')
      localStorage.removeItem('sysUserId')
      localStorage.removeItem('isOBT')
      localStorage.clear()
    },
    // 进入其他页面
    goToPage: function(str){
      this.$store.state.activeNav = 2
      this.$store.state.selStudentName = ''
      this.$store.state.selParentName = ''
      this.$store.state.selFamilyName = ''
      this.$router.push({ name: str});
    },
    // 修改密码
    editPwd: function() {
      this.$router.push({ name: 'login', params: { type: 2 } });
    },
    // 返回按钮事件
    goBack: function() {
      if (location.href.indexOf('login') != -1) {
        this.$emit('prePage');
      } else {
        this.$router.go(-1); //返回上一层
      }
    },
    // 改变语言
    changeLanguage: function() {
      if (this.$store.state.languageBtn == 'English') {
        this.$language(1);
      } else {
        this.$language(0);
      }
    },
    // 进入个人中心
    goToPersonal: function(url) {
      this.$store.state.topIndex = '-1';
      if(this.$route.path.split('/')[2] != this.$store.state.sysUserId){
         this.$router.push({
          name: 'personal',
          params: { sysUserId: this.$store.state.sysUserId }
        });
      }
    },
    // 改变消息设置
    changeNews: function(status){
      var params = {
        id: this.$store.state.institutionUserId,
      }
      if(status){
        params.enableNotify = '1';
      }else{
        params.enableNotify = '2';
      }
      this.$post('/institutionUser/modifyUser', params,0,false).then(res=>{
        this.selPersonal();
      }).catch(err => {
        this.$Message.error(err.message);
      });
    },
    // 获取机构用户个人信息
    selPersonal() {
      this.$post('/institutionUser/queryInfo', { sysUserId: localStorage.getItem('sysUserId') },0,false).then(res => {
        const {basicInfo,department} = res
        if(res.department.path){
            res.department.isLeader = false
            let departmentPath=[]
            for(let m of res.department.path.split('/')){
              if(m&&m.length>0){
                departmentPath.push(m)
              }
            }
            if(departmentPath.length>1){
              res.department.isLeader = true
            }
        }
        this.$store.state.basicInfo = basicInfo
        this.$store.state.department = department
        this.$store.state.institutionUserId = basicInfo.id
        this.$store.state.listUserRole = basicInfo.listUserRole
        this.$store.state.sysUserId = basicInfo.sysUserId
        this.setTime()
      }).catch(err => {
        this.$Message.error(err.message);
      });
    },
    // 设置计时器
    setTime: function() {
      this.timeArr = this.$timeChange(new Date(), 6, 3, this.calendarTimezone)
      setInterval(() => {
        this.timeArr = this.$timeChange(new Date(), 6, 3, this.calendarTimezone)
      }, 60000);
    },
    // 查询用户消息列表
    selMsg: function(){
      var params = {
        id: this.$store.state.sysUserId,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      }
      var language = this.$store.state.language;
      this.$post('/notify/list', params).then(res => {
        this.xiaoxi = [];
        for(var m of res){
          m.gmtCreate = this.$timeChange(m.gmtCreate,2,2);
          m.type = Number(m.type);
          switch (m.type) {
            case 1:
              m.typeText = [language.family,language.familyMainConsultant,language.ntfctNewFamily];
              break;
            case 2:
              m.typeText = [language.task,language.taskNewTask,language.ntfctNewTask];
              break;
            case 3:
              m.typeText = [language.task,language.taskTaskDue];
              break;
            case 4:
              m.typeText = [language.feedback,language.taskTaskDue];
              break;
            case 5:
              m.typeText = [language.program,language.programNewMember,language.ntfctNewProgram];
              break;
            case 6:
              m.typeText = [language.program,language.programAppCompleted,language.ntfctCompletedTS];
              break;
            case 7:
              m.typeText = [language.program,language.sessionNewSessions,language.ntfctNewSession];
              break;
            case 8:
              m.typeText = [language.session,language.sessionTodaysSessions];
              break;
            case 9:
              m.typeText = [language.session,language.sessionCancellationRequestNtfct,language.ntfctNewRequest];
              break;
            case 10:
              m.typeText = [language.session,language.sessionCancellationResultNtfct];
              break;
            case 11:
              m.typeText = [language.homework,language.taskTaskDue];
              break;
          }
          this.xiaoxi.push(m);
        }
      })
    },
    //新增反馈查学生详情
    selCustomInfo(customerId) {
      return new Promise((resolve,reject) =>{
        this.$post('/customerUser/queryCustInfo', { id: customerId })
          .then(res => {
            resolve(JSON.parse(JSON.stringify(res)))
          })
          .catch(err => { });
      })
    },
    // 进入其他页面
    async goToMsgPage(item){
      switch (item.type) {
        case 1:
          this.$router.push({
            name: 'familyDetail',
            query: { familyId: item.value }
          });
          break;
        case 2:
          this.$router.push({name: "task"});
          break;
        case 3:
          this.$router.push({name: "task"});
          break;
        case 4:
          this.$store.state.currentStu = await this.selCustomInfo(item.value)
          this.$store.state.activeNavStu = 4
          this.$router.push({name: "stuMsg",params: { id: item.value }});
          break;
        case 5:
          this.$router.push({name: "objMsg",params: {objId: item.value,type: 1}});
          break;
        case 7:
          this.$router.push({name: "teClass"});
          break;
        case 9:
          this.$router.push({name: "teClass"});
          break;
        case 12:
          this.$store.state.currentStu = await this.selCustomInfo(item.value)
          this.$store.state.activeNavStu = 12
          this.$router.push({name: "stuMsg",params: { id: item.value}});
          break;
      }
    },
    // 查询用户未读消息条数
    selWeidu: function(){
      var params = {
        id: this.$store.state.sysUserId,
      }
      this.$post('/notify/countUnread', params).then(res => {
        this.weidu = res;
      })
    },
    // 标记已读
    biaoYidu: function(){
      if(this.weidu>0){
        this.$post('/notify/readMark', {viewUser: this.$store.state.sysUserId}).then(res => {
          this.weidu = 0;
        })
      }
    },
  },
  mounted() {
      // 判断是否登陆
      this.$isLogin().then(res=>{
        this.isSp = this.$store.state.isSp
        this.roleId = this.$store.state.roleId;
        // this.quanxian = this.$store.state.userRolePower[this.roleId];
        // 设置计时器
        this.setTime();
        // 查询用户消息列表
        this.selMsg();
        // 查询用户未读消息条数
        this.selWeidu();
        if(this.$store.state.basicInfo.enableNotify!=1){
          this.newsKaiguan = false;
        }
      })
  },
  watch: {
    newsKaiguan(){
      this.selMsg()
      this.selWeidu()
    }
  },
  computed:{
      calendarTimezone(){
        return this.$store.getters.areaCodeString
      }
    }
  };
  
</script>

<style scoped>
.topBar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 40px;
  padding-left: 30px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: #12273F;
  z-index: 999;
  color: #FFFFFF;
  height: 72px;
}

.logo {
  width: 110px;
  flex-shrink: 0;
}

.ivu-menu-item {
  flex-shrink: 0;
}

.center {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  padding-left: 7%;
}

.center .menuItem{
  padding: 16px 18px 14px 18px;
  border-radius: 6px;
  font-size: 16px;
  margin-right: 5px;
  color:rgba(255, 255, 255, 0.7);
}

.center .menuItem:hover{
  color:#fff;
  background-color: rgba(255, 255, 255, 0.1);
}

.center .menuItem.true{
  background-color: #F0F2F4;
  color: #12273F;
  font-weight: bold;
}

.shuxian{
  width: 1px;
  height: 14px;
  background-color: #767D84;
  margin: 0 10px;
}

.right {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.ling {
  width: 18px;
  height: 22px;
}

.ling > img{
  width: 18px;
}

.ling >>> .ivu-badge-count{
  height: 12px;
  padding: 0 2px;
  line-height: 10px;
  min-width: 10px;
  top: -5px;
}

.renWai {
  margin-right: 20px;
  position: relative;
}

.ren {
  width: 36px;
  height: 36px;
  border-radius: 18px;
  border: 2px solid rgba(255, 255, 255, 0.6);
}

.ren:hover{
  border-color: #fff;
}

.renWai .erji {
  width: 260px;
  position: absolute;
  top: 45px;
  left: -110px;
  background-color: #fff;
  z-index: 999;
  display: none;
  color: #000;
  border-radius: 10px;
  box-shadow: 0px 24px 52px 0px rgb(234,239,242);
}
.renWai .erjiSg {
  right: -10px;
  left: auto;
}

.sanjiao{
  width: 0;
  height: 0;
  border: 10px solid transparent;
  border-top-color: #fff;
  transform: rotate(180deg);
  margin-top: -19px;
  margin-left: 117px;
  margin-bottom: 20px;
}
.sanjiaoSg{
  margin-left: 224px;
}

.renWai:hover .erji {
  display: block;
}

.people {
  font-size: 12px;
  color: #767D84;
  padding: 0 30px;
  padding-bottom: 12px;
  border-bottom: 1px dashed #E9EDEF;
}

.people p:first-child{
  font-size: 24px;
  color: #181E24;
  font-weight: bold;
  margin-bottom: 0px;
}

.loginOut{
  width: 200px;
  height: 42px;
  text-align: center;
  line-height: 42px;
  color: #F56060;
  background-color: rgba(245,96,96, 0.1);
  border-radius: 4px;
  font-weight: bold;
  margin: 0 auto;
  margin-top: 25px;
}

.renWai .erji .one {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  padding: 0 30px;
  color: #767D84;
  font-size: 14px;
}

.belogo{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  color: #767D84;
  font-size: 12px;
  padding-bottom: 20px;
}

.belogo img {
  width: 23px;
  margin: 0 auto;
  margin-right: 3px;
  margin-left: 0;
}

.renWai .erji > p {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.3);
  font-weight: bold;
  margin-top: 5px;
}

.language{
  background-color: #657991;
  border-radius: 5px;
  width: 60px;
  height: 26px;
  display: flex;
  color: #ffffff;
  font-size: 12px;
  margin-left: 15px;
}

.language > p{
  width: 30px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  border-radius: 5px;
}

.language0 > p:last-child,.language1 > p:first-child{
  background-color: #ffffff;
  color: #17375B;
  font-weight: bold;
}

.location {
  display: flex;
  align-items: center;
  font-size: 12px;
  margin-right: 10px;
}

.addrIcon{
  width: 12px;
  height: 15px;
  margin-top: -1px;
}

.addr {
  margin-left: 8px;
  font-size: 16px;
}

.timeIcon{
  width: 14px;
  height: 14px;
  margin-left: 30px;
}

.location .time {
  margin-left: 6px;
  font-size: 16px;
  font-weight: bold;
}

.shanshuo {
  animation: shanshuo 1s infinite linear;
  margin: 0 2px;
}

@keyframes shanshuo {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.tixing{
  width: 360px;
  color: #000;
  padding: 10px 5px;
}

.tixing .list{
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
  padding-bottom: 15px;
  border-bottom: 1px dashed #E9EDEF;
}

.tixing .list:first-child{
  margin-top: 0;
}

.tixing .list .left{
  width: 250px;
}

.tixing .list .left p:first-child{
  font-size: 16px;
  color: #181E24;
  font-weight: 600;
}

.tixing .list .left p:first-child span{
  color: #0BA8E5;
}

.tixing .list .left p:nth-child(2){
  font-size: 14px;
  color: #0F1C34;
  white-space: pre-wrap;
  line-height: 1.3em;
}

.tixing .list .left p:nth-child(3){
  margin-top: 5px;
  font-size: 12px;
  color: #767D84;
}

.tixing .list .right{
  color: #0BA8E5;
  font-size: 12px;
  border-radius: 4px;
  border: 0.5px solid #0BA8E5;
  height: 22px;
  padding: 0 10px;
}

.tixingText{
  text-align: center;
  color: #B3B9BE;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/topBar.vue